import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../commonComponents/modal/Modal';
import ModalFooter from '../../commonComponents/modal/ModalFooter';
import { UserCard } from '../teams/structure/TeamStructureUserCard';
import ModalHeader from '../../commonComponents/modal/ModalHeader';
import ScrollContainer from '../../commonComponents/container/ScrollContainer';
import FormInput from '../../commonComponents/forms/FormInput';
import RadioBtn from '../../commonComponents/forms/inputs/RadioBtn';

const BinaryTreeModal = ({
  t,
  userModal,
  toggleModal,
  availableUsers,
  addUserToTheTree,
  selectedAvailableUser,
  setSelectedAvailableUser,
  binaryParent,
  userTypeNames,
  directSellingSettings,
  selectedUserDetails,
  query,
  setQuery,
  onReachedEnd,
}) => {
  const onSave = useCallback(() => {
    addUserToTheTree(userModal.data?.side);
    toggleModal();
    setQuery('');
  }, [addUserToTheTree, toggleModal, setQuery]);

  const onClose = useCallback(() => {
    toggleModal();
    setQuery('');
    setSelectedAvailableUser(undefined);
  }, [toggleModal, setQuery]);

  const handleQuery = useCallback(value => setQuery(value), [setQuery]);
  return (
    userModal.show && (
      <Modal onClose={toggleModal} tabIndex={null}>
        <div className="popup-container">
          <div className="popup">
            <ModalHeader title={`${t('add_related_user_to')}:`} />
            <div className="popup-user-card-container">
              <div className="connect-structure-level-container card-onPopup">
                <div className="connect-structure-level">
                  <div className="connect-structure-user-list">
                    <div className="structure-card">
                      <UserCard
                        t={t}
                        avatar={
                          binaryParent.image
                            ? binaryParent.image.thumb
                            : '/images/no_user.png'
                        }
                        user={binaryParent}
                        userTypeNames={userTypeNames}
                        selectedUserDetails={selectedUserDetails}
                        directSellingSettings={directSellingSettings}
                        isSponsorTree={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h3 className="users-toAdd-title">{t('users_to_add')}</h3>
            <FormInput
              id="search"
              name="search"
              value={query}
              onChange={handleQuery}
              labelClassName=""
              containerClassName=""
              placeholder={t('user_selector_placeholder')}
              groupProps={{
                className: 'query-container',
              }}
            />
            <ScrollContainer onReachedEnd={onReachedEnd}>
              {availableUsers.map(user => (
                <div
                  role="presentation"
                  className="popup-user"
                  onClick={() => {
                    setSelectedAvailableUser(user._id);
                  }}
                >
                  <RadioBtn
                    id={user._id}
                    checked={selectedAvailableUser === user._id}
                  />
                  <img
                    className="popup-avatar"
                    alt={user.name}
                    src={user.image ? user.image.thumb : '/images/no_user.png'}
                  />
                  <p>{user.username}</p>
                </div>
              ))}
            </ScrollContainer>
            <ModalFooter
              onCancel={onClose}
              onSave={onSave}
              saveText={t('add')}
              cancelText={t('cancel')}
            />
          </div>
        </div>
      </Modal>
    )
  );
};

BinaryTreeModal.propTypes = {
  t: PropTypes.func.isRequired,
  userModal: PropTypes.shape({
    show: PropTypes.bool.isRequired,
    data: PropTypes.shape({
      side: PropTypes.oneOf(['left', 'right']).isRequired,
    }).isRequired,
  }).isRequired,
  toggleModal: PropTypes.func.isRequired,
  availableUsers: PropTypes.shape([]).isRequired,
  addUserToTheTree: PropTypes.func.isRequired,
  setSelectedAvailableUser: PropTypes.func.isRequired,
  selectedAvailableUser: PropTypes.shape([]).isRequired,
  binaryParent: PropTypes.shape({ image: PropTypes.string.isRequired })
    .isRequired,
  directSellingSettings: PropTypes.shape({}).isRequired,
  userTypeNames: PropTypes.shape({}).isRequired,
  selectedUserDetails: PropTypes.shape({}).isRequired,
  query: PropTypes.string.isRequired,
  setQuery: PropTypes.func.isRequired,
  onReachedEnd: PropTypes.func.isRequired,
};

export default BinaryTreeModal;
